import Section from '/components/elements/Section'
import Container from '../../../elements/Container'
import styles from './styles.module.scss'
import Columns from '../../../layout/Columns'
import Column from '../../../layout/Column'
import data from './data'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { useRouter } from 'next/router'

const Features = ({ translations }) => {
  const { isMobile, isSmallMobile } = useResponsive()
  const router = useRouter()

  return (
    <Section variant={['white', 'center']}>
      <Container>
        <span className={styles.subtitle}>
          {translations.label[router.locale]}
        </span>

        <h2
          dangerouslySetInnerHTML={{
            __html: translations.title[router.locale]
          }}
          className={styles.title}
        ></h2>

        <Columns className={styles.columns} variant={['-align-center']}>
          {data.map((feature, index) => (
            <Column
              key={`feature-${index}`}
              spans={isSmallMobile ? 12 : isMobile ? 6 : 4}
            >
              <div className={styles.feature}>
                <div className={styles.feature__icon}>{feature.icon}</div>

                <h3 className={styles.feature__title}>
                  {translations.features[index].title[router.locale]}
                </h3>

                <p>{translations.features[index].description[router.locale]}</p>
              </div>
            </Column>
          ))}
        </Columns>
      </Container>
    </Section>
  )
}

export default Features
